import { Store } from 'react-notifications-component';
import { ReactElement } from 'react';

const settings = (duration?: number) => {
	return {
		insert: 'bottom',
		container: 'bottom-right',
		animationIn: ['animate__animated', 'animate__fadeIn'],
		animationOut: ['animate__animated', 'animate__fadeOut'],
		dismiss: {
			duration: duration ?? 5000,
			pauseOnHover: true,
			onScreen: true,
			showIcon: true,
			waitForAnimation: true,
		},
	};
};

const showNotification = (title: string | ReactElement, message: string | ReactElement, type = 'default', duration?: number): void => {
	Store.addNotification({
		title,
		message,
		// @ts-ignore
		type,
		...settings(duration),
	});
};

export default showNotification;
